
/**
 * @description
 * 로드맵 상세 > 요약에 붙어있는 찜하기 버튼
 */
import { mapGetters } from 'vuex';

import Icon from '@/components/common/icon/Icon.vue';

export default {
  name: 'DetailCourseFavorite',
  components: { Icon },
  computed: {
    ...mapGetters('course', ['favoriteCount', 'id', 'favoriteCourseObj']),
    ...mapGetters('user/favorite', ['favoriteCourseIds']),
    isFavoriteCourse: ({ favoriteCourseIds, id }) =>
      favoriteCourseIds.includes(id),
  },
  methods: {
    onClickFavorite() {
      this.$emit('on-click-favorite');
    },
  },
};
